module.exports = __webpack_public_path__ + "static/network-headers-2183677eceb7827116bb7147e2f56b24.png";